"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSeasonGroup = void 0;
const season_1 = require("./season");
function mockSeasonGroup(overrides = {}) {
    return {
        active: false,
        display_name: 'Mock display_name',
        name: 'mock_name',
        seasons: [(0, season_1.mockSeason)()],
        ...overrides,
    };
}
exports.mockSeasonGroup = mockSeasonGroup;
